import { defineComponent as o, createBlock as r, openBlock as c, unref as a, mergeProps as p, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const s = /* @__PURE__ */ o({
  name: "IconBellAlert",
  __name: "IconBellAlert",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const n = l;
    return (u, t) => (c(), r(a(d), p(n, { "view-box": "0 0 24 24" }), {
      default: m(() => t[0] || (t[0] = [
        e("path", { d: "M5.283 2.173a.75.75 0 0 1 .526 1.404c-1.012.38-3.388 2.263-3.016 6.736A.75.75 0 0 1 1.3 10.437C.87 5.31 3.629 2.793 5.283 2.173m13.434 0a.75.75 0 0 0-.526 1.404c1.012.38 3.388 2.263 3.016 6.736a.75.75 0 1 0 1.494.124c.428-5.127-2.33-7.644-3.984-8.264" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M7.25 3.967c1.27-1.185 2.98-1.842 4.754-1.842 1.773 0 3.485.658 4.755 1.842 1.308 1.221 1.995 3.262 1.995 4.908v3.5c0 1.795.904 2.473 1.292 2.694.365.208.708.623.708 1.17v.136a1.25 1.25 0 0 1-1.25 1.25h-15a1.25 1.25 0 0 1-1.25-1.25v-.123c0-.562.36-.982.733-1.186.374-.206 1.267-.855 1.267-2.69v-3.5c0-1.647.687-3.688 1.995-4.909m1.023 1.097C7.33 5.943 6.754 7.551 6.754 8.875v3.5c0 2.082-.904 3.197-1.648 3.75h13.822c-.74-.554-1.674-1.677-1.674-3.75v-3.5c0-1.324-.577-2.932-1.519-3.811-.982-.916-2.324-1.439-3.73-1.439-1.409 0-2.75.523-3.732 1.439",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M10.764 19.282a.75.75 0 0 0-1.489.186 2.75 2.75 0 0 0 5.458 0 .75.75 0 1 0-1.489-.186 1.25 1.25 0 0 1-2.48 0" }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  s as default
};
